import { render, staticRenderFns } from "./ListProducts.vue?vue&type=template&id=2860c6e0&"
import script from "./ListProducts.vue?vue&type=script&lang=js&"
export * from "./ListProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports